import { CanDeactivateFn } from '@angular/router';

/** Anything that can hold edits the server doesn't have yet. */
export interface HasUnsavedChanges {
  canDeactivate(): Promise<boolean> | boolean;
}

/** Root CV editor (chamba-ai#405 F1a): leaving the route waits for the
 * debounced autosave to land instead of dropping the last edit. */
export const rootCvUnsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) =>
  component?.canDeactivate ? component.canDeactivate() : true;
